import React from "react";
import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal for kinetic headlines.
 * Each element in `lines` should be a string or JSX.
 */
export default function RevealLines({ lines, className = "", delay = 0, staggerChildren = 0.09 }) {
  return (
    <motion.h1
      initial="hidden"
      animate="visible"
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren, delayChildren: delay } },
      }}
      className={className}
    >
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.05em]"
          style={{ lineHeight: "0.98" }}
        >
          <motion.span
            className="block will-change-transform"
            variants={{
              hidden: { y: "110%", opacity: 0 },
              visible: {
                y: "0%",
                opacity: 1,
                transition: {
                  y: { duration: 1.05, ease: [0.22, 1, 0.36, 1] },
                  opacity: { duration: 0.6, ease: "easeOut" },
                },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
}
